exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mS9qLdAYo8Veu-YFIQETF{font-size:13px}", ""]);
// Exports
exports.locals = {
	"monaco-quick-open-widget": "mS9qLdAYo8Veu-YFIQETF"
};